import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ServicesService} from '../services.service';
import {environment} from '../../environments/environment';
import { get } from 'scriptjs';
declare var Eftx: any;

@Component({
  selector: 'app-make-payment-eft',
  templateUrl: './make-payment-eft.component.html',
  styleUrls: ['./make-payment-eft.component.css']
})
export class MakePaymentEftComponent implements OnInit {

    header = 'l-header';
    navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    webBaseUrl: string        = environment.webBaseUrl;
    apiBaseUrl: string        = environment.apiBaseUrl;
    apiUrl: string        = environment.apiUrl;

    merchantName = 'Oneills Photography';
    merchantBank = '';
    paymentKey = '';
    yourCancelUrl = this.apiUrl+'/payment/response-eft';
    yourCompleteUrl = this.apiUrl+'/payment/response-eft';
    amount = 0;

    constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) {
    }

  ngOnInit() {
    
      const userData = JSON.parse(localStorage.getItem('userData'));
      const token = localStorage.getItem('userToken');
      const user_id = userData.hasOwnProperty('id') ? userData.id : '';
      const data = {'token': token };

      this._service.getorderPrice(data).subscribe((res: any) => {
          if (res.status === 200) {
              const data = {
                  'token': token
              };

              this.amount = res.result;
              this._service.getPaymentKey(data).subscribe((res: any) => {

                  if(res.status == 200){
                      this.paymentKey = res.result.key;
                      get("https://eft.ppay.io/js/eft-secure.min.js" , ()=> {
                          this.initiateEftPayment();
                        });
                  }else{
                    //   this.router.navigate(['login']);
                  }

              });
          }else {
            //   this.router.navigate(['login']);
          }
      });
  }

    initiateEftPayment(){

        setTimeout(() => {
            $('.tb-preloader-wave').fadeOut();
            $('#tb-preloader').delay(200).fadeOut('slow').remove();
            document.getElementById('loader').style.display = 'none';
        }, 1500);

        new Eftx({
            key: this.paymentKey,
            formId: "eftx-form",
            titleId: "eftx-title",
            subTitleId: "eftx-subtitle",
            cssFramework: "bootstrap",
            buttonContainerId: "eftx-button-container",
            onCancelUrl: this.yourCancelUrl,
            onCompleteUrl: this.yourCompleteUrl,
            onLoadStart: function(){
                $("#loader").hide();
                $("#eftx-form").hide();
                $("#eftx-button-container").hide();
                //Do other stuff here
            },
            onLoadStop: function(){
                $("#loader").addClass("hide");
                $("#eftx-form").show();
                $("#eftx-button-container").show();
                //Do other stuff here
            }
        });


      //   new Eftx({
      //     key: this.paymentKey,
      //     cssFramework: "bootstrap",
      //     buttonContainerId: "eftx-button-container",
      //     onCancelUrl: this.yourCancelUrl,
      //       onCompleteUrl: this.yourCompleteUrl,
      //     backgroundEnabled: true,
      //     onLoadStart: function(){
      //         $(".eftx-loader").removeClass("hide"); $("#eftx-form").hide();
      //         $(".modal-footer button").hide();
      //         //Do other stuff here
      //     },
      //     onLoadStop: function(){
      //         $(".eftx-loader").addClass("hide"); $("#eftx-form").show();
      //         $(".modal-footer button").show();
      //         //Do other stuff here
      //     }
      // });
    }

    //http://localhost:4200/online-photo-order?success=true&merchant_reference=testref123&gateway_reference=1243760&transaction_id=1243760&organisation_id=1003&payment_key=de7bc68087f079da257664a9a021fefd&status=success

    //http://localhost:4200/online-photo-order?success=false&merchant_reference=testref123&gateway_reference=1243822&transaction_id=1243822&organisation_id=1003&payment_key=de7bc68087f079da257664a9a021fefd&status=error

    //http://localhost:4200/online-photo-order?success=false&merchant_reference=testref123&gateway_reference=1243825&transaction_id=1243825&organisation_id=1003&payment_key=de7bc68087f079da257664a9a021fefd&status=cancel

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/make-payment-eft/make-payment-eft.component.ts